const musicLinksDE = {
    "view": {
        "table": {
            "title": "Ihre Musiklink-Liste",
            "column": {
                "releaseName": "Veröffentlichungsname",
                "artists": "Künstler",
                "owner": "Besitzer",
                "created": "Erstellt",
                "musicLink": "Musiklink",
                "action": "Aktion"
            },
            "button": {
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "message": {
                "linkCopied": "Link in die Zwischenablage kopiert!"
            }
        },
        "modal": {
            "edit": {
                "header": "{{musicLinkName}} bearbeiten?",
                "body": "Sind Sie sicher, dass Sie diesen Musiklink bearbeiten möchten?"
            },
            "delete": {
                "header": "{{musicLinkName}} löschen?",
                "body": "Sind Sie sicher, dass Sie diesen Musiklink löschen möchten?"
            }
        },
        "message": {
            "success": "Musiklink wurde entfernt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "mlAllowanceSpent": "Sie haben Ihr Musiklink-Kontingent aufgebraucht. Um mehr Musiklinks zu erstellen, aktualisieren Sie bitte Ihr Konto oder kontaktieren Sie unser Support-Team.",
            "subscriptionFeatureUnavailable": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "moduleAccessRestricted": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "add": {
        "title": "Musiklink hinzufügen",
        "form": {
            "label": {
                "source": "Quelle",
                "subUser": "Unterbenutzer",
                "release": "Veröffentlichung",
                "artwork": "Artwork",
                "releaseName": "Veröffentlichungsname",
                "upcEan": "UPC/EAN",
                "artistName": "Künstlername",
                "urlPart1": "URL Teil 1",
                "urlPart2": "URL Teil 2",
                "musicLinkUrl": "Ihre Musiklink-URL ist",
                "searchBy": "Suchen nach",
                "upcNumber": "UPC-Nummer",
                "storeReleaseUrl": "Store-Veröffentlichungs-URL",
                "colorCustomisation": "Farbgestaltung",
                "premadeColors": "Vorgefertigte Farben",
                "customColors": "Benutzerdefinierte Farben",
                "buttonStyle": "Button-Stil",
                "headerBackground": "Header-Hintergrund",
                "singleColor": "Einzelfarbe",
                "gradient": "Verlauf",
                "playerControlsColor": "Farbe der Player-Steuerung",
                "titleColor": "Titel-Farbe",
                "descriptionColor": "Beschreibung-Farbe",
                "buttonColor": "Button-Farbe",
                "buttonHoverColor": "Button-Hover-Farbe",
                "buttonTextColor": "Button-Textfarbe"
            },
            "placeholder": {
                "subUser": "Unterbenutzer auswählen...",
                "release": "Veröffentlichung auswählen",
                "releaseUpc": "Veröffentlichungs-UPC/EAN-Nummer eingeben, z.B. 5055964352523",
                "releaseStoreUrl": "Veröffentlichungs-Store-URL eingeben, z.B. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn oder www.deezer.com/en/album/413370367",
                "urlPart1": "URL Teil 1 auswählen"
            },
            "help_text": {
                "subUser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Musiklink für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unmarkiert.",
                "release": "Hinweis: Sie können nur Veröffentlichungen auswählen, die <strong>vertrieben</strong> wurden.",
                "releaseUpc": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist.",
                "releaseStoreUrl": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist."
            },
            "options": {
                "source": {
                    "existingRelease": "Bestehende Musiklink-Veröffentlichung",
                    "externalRelease": "Externe Veröffentlichung"
                },
                "buttonStyle": {
                    "outlined": "Umrandet",
                    "filled": "Gefüllt"
                }
            },
            "button": {
                "reset": "Zurücksetzen",
                "createNew": "Neu erstellen?",
                "submit": "Einreichen"
            },
            "validation": {
                "formInvalid": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "storeUrlRequired": "{{store}} URL ist erforderlich",
                "storeUrlValid": "Bitte fügen Sie eine gültige {{store}} URL hinzu."
            }
        },
        "message": {
            "success": "Musiklink wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "fetchingReleaseDetails": "Veröffentlichungsdetails werden abgerufen..."
        }
    },
    "update": {
        "title": "Musiklink bearbeiten",
        "form": {
            "label": {
                "source": "Quelle",
                "release": "Veröffentlichung",
                "artwork": "Artwork",
                "releaseName": "Veröffentlichungsname",
                "upcEan": "UPC/EAN",
                "artistName": "Künstlername",
                "urlPart1": "URL Teil 1",
                "urlPart2": "URL Teil 2",
                "musicLinkUrl": "Ihre Musiklink-URL ist",
                "searchBy": "Suchen nach",
                "upcNumber": "UPC-Nummer",
                "storeReleaseUrl": "Store-Veröffentlichungs-URL",
                "colorCustomisation": "Farbgestaltung",
                "premadeColors": "Vorgefertigte Farben",
                "customColors": "Benutzerdefinierte Farben",
                "buttonStyle": "Button-Stil",
                "headerBackground": "Header-Hintergrund",
                "singleColor": "Einzelfarbe",
                "gradient": "Verlauf",
                "playerControlsColor": "Farbe der Player-Steuerung",
                "titleColor": "Titel-Farbe",
                "descriptionColor": "Beschreibung-Farbe",
                "buttonColor": "Button-Farbe",
                "buttonHoverColor": "Button-Hover-Farbe",
                "buttonTextColor": "Button-Textfarbe"
            },
            "placeholder": {
                "release": "Veröffentlichung auswählen",
                "releaseUpc": "Veröffentlichungs-UPC/EAN-Nummer eingeben, z.B. 5055964352523",
                "releaseStoreUrl": "Veröffentlichungs-Store-URL eingeben, z.B. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn oder www.deezer.com/en/album/413370367",
                "urlPart1": "URL Teil 1 auswählen"
            },
            "help_text": {
                "release": "Hinweis: Sie können nur Veröffentlichungen auswählen, die <strong>vertrieben</strong> wurden.",
                "releaseUpc": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist.",
                "releaseStoreUrl": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie eine Veröffentlichung hinzufügen möchten, die bereits auf Spotify oder Deezer ist."
            },
            "options": {
                "source": {
                    "existingRelease": "Bestehende Musiklink-Veröffentlichung",
                    "externalRelease": "Externe Veröffentlichung"
                },
                "buttonStyle": {
                    "outlined": "Umrandet",
                    "filled": "Gefüllt"
                }
            },
            "button": {
                "reset": "Zurücksetzen",
                "createNew": "Neu erstellen?",
                "submit": "Einreichen"
            },
            "validation": {
                "formInvalid": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "storeUrlRequired": "{{store}} URL ist erforderlich",
                "storeUrlValid": "Bitte fügen Sie eine gültige {{store}} URL hinzu."
            }
        },
        "message": {
            "success": "Musiklink wurde aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "fetchingReleaseDetails": "Veröffentlichungsdetails werden abgerufen..."
        }
    },
    "storeLinksRow": {
        "title": "Store-Links",
        "label": {
            "store": "Store",
            "link": "Link"
        },
        "button": {
            "remove": "Entfernen"
        },
        "model": {
            "addStore": {
                "header": "Store hinzufügen",
                "body": "Bitte wählen Sie den gewünschten Store aus der Liste unten aus:",
                "option": {
                    "mainStores": "Haupt-Stores",
                    "otherStores": "Andere Stores"
                },
                "button": {
                    "add": "Store hinzufügen",
                    "cancel": "Abbrechen"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Vorschau-Dateien",
        "label": {
            "preview": "Vorschau",
            "artistName": "Künstlername",
            "trackName": "Trackname"
        },
        "audioNotSupported": "Ihr Browser unterstützt das Audioelement nicht."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Musikdienst wählen",
            "track": "Track",
            "artist": "Künstler",
            "time": "Zeit",
            "others": "Andere"
        },
        "button": {
            "play": "Abspielen"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Statistiken für Musiklink werden abgerufen"
        },
        "topServices": {
            "title": "Top-Dienste",
            "subtitle": "KLICK DURCH NACH DIENST",
            "table": {
                "column": {
                    "store": "Store",
                    "noOfVisits": "Gesamtbesuche",
                    "noOfVisitsPct": "Gesamtbesuche %"
                },
                "label": {
                    "otherStores": "Andere Stores"
                }
            }
        },
        "topTracks": {
            "title": "Top-Tracks",
            "subtitle": "KLICK DURCH NACH TRACK",
            "table": {
                "column": {
                    "trackName": "Trackname",
                    "artistName": "Künstlername",
                    "noOfPlays": "Anzahl der Wiedergaben",
                    "noOfPlaysPct": "Anzahl der Wiedergaben %"
                }
            }
        },
        "topTerritories": {
            "title": "Top-Gebiete",
            "subtitle": "KLICK DURCH NACH GEBIET",
            "table": {
                "column": {
                    "territory": "Gebiet",
                    "noOfViews": "Anzahl der Ansichten",
                    "noOfViewsPct": "Anzahl der Ansichten %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Top-Gerätetypen",
            "subtitle": "KLICK DURCH NACH GERÄTETYP"
        },
        "topOperatingSystems": {
            "title": "Top-Betriebssysteme",
            "subtitle": "KLICK DURCH NACH OS",
            "chart": {
                "label": {
                    "noOfViews": "Anzahl der Ansichten : ",
                    "operatingSystems": "Betriebssystem"
                }
            }
        },
        "topBrowsers": {
            "title": "Top-Browser",
            "subtitle": "KLICK DURCH NACH BROWSER",
            "table": {
                "column": {
                    "browser": "Browser",
                    "noOfViewsPct": "Anzahl der Ansichten (%)"
                }
            }
        }
    }
};

export default musicLinksDE;